<template>
  <div class="pageContainer app-container">
    <el-row class="flexStart">
      <el-date-picker size="small"
          v-model="searchForm.rangeDate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
      </el-date-picker>


      <el-button size="small" icon="el-icon-search" @click="onSearch" plain type="primary" style="margin-left: 10px;">查询</el-button>

    </el-row>

    <el-row type="flex" :gutter="16" style="margin-top: 20px">
      <el-col :span="24" class="tabContainer">
        <el-tabs v-model="activeName" type="border-card" style="height: 100%;">
          <el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">
            <el-table :data="qstList" stripe size="mini" style="width: 100%;margin-bottom: 20px;" border>
              <el-table-column prop="index" width="55" label="序号">
                <template slot-scope="scope">
                  {{scope.$index+1+((page.pageIndex-1)*page.pageSize)}}
                </template>
              </el-table-column>
              <el-table-column v-if="false" type="expand">
                <template slot-scope="scope">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <el-form-item label="商品名称">
                      <span>{{ scope.row.name }}</span>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>

              <el-table-column prop="question" label="问题咨询">
                <template slot-scope="scope">
                  <div class="flexStartUp">
                    <div>
                      <img :src="'./images/temp.jpg'" alt="" style="width: 50px;height: 50px">
                    </div>
                    <div class="flexCloumn" style="margin-left: 20px" >
                      <div style=" color: #9a9a9a;font-size: 14px;">
                        {{scope.row.nickName}}
                      </div>
                      <div style=" color: #9a9a9a;">
                        {{scope.row.question}}
                      </div>
                      <div style=" color: #9a9a9a;margin-top: 10px;">
                        {{scope.row.time}}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="time" label="咨询日期" width="140"></el-table-column>
              <el-table-column label="操作" width="140">
                <template slot-scope="scope">
                  <el-button icon="el-icon-chat-line-round" @click="showReply(scope.row)" type="text" size="small">回复</el-button>

                </template>
              </el-table-column>
            </el-table>

          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-dialog :title="modalTitle" width="800px" :visible.sync="visible" :close-on-click-modal="false">



        <div class="flexStartUp">
          <div>
            <img :src="'./images/temp.jpg'" alt="" style="width: 50px;height: 50px">
          </div>
          <div class="flexCloumn" style="margin-left: 20px" >
            <div style=" color: #9a9a9a;font-size: 14px;">
              {{editForm.nickName}}
            </div>
            <div style=" color: #9a9a9a;">
              {{editForm.question}}
            </div>
            <div style=" color: #9a9a9a;margin-top: 10px;">
              {{editForm.time}}
            </div>
          </div>
        </div>
        <div class="flexStartUp" style="margin-top: 20px;width: 100%;">
          <span style="width: 70px;text-align: center;">回复:</span>
          <div class="flex_1">
            <el-input v-model.trim="editForm.replyContent" type="textarea"
                      :autosize="{ minRows: 4, maxRows: 10 }" style="width: 90%" />
          </div>
        </div>


      <div slot="footer">
        <el-button size="mini" el-icon="el-icon-remove" type="primary" @click="reply">提交回复</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import api from '@/api/api';

export default {
  name: 'Student',
  components: {
  },
  data () {
    return {
      searchForm:{ktype:'stu_name',status:1},//查询
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      visible:false,
      modalTitle:'回复',
      editForm:{},
      //tree
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'title'
      },
      //table
      tabMapOptions: [
        { label: '问题列表', key: 'CN' },
      ],
      activeName: 'CN',
      page:{
        pageIndex:1,
        pageSize:20,
        pageSizes:[20,50],
        total:0
      },

      teacherId:null,

      qstList:[]
    }
  },
  watch: {
    activeName(val) {
      this.$router.push(`${this.$route.path}?tab=${val}`)
    }
  },
  created() {
    // init the default selected tab
    const tab = this.$route.query.tab
    if (tab) {
      this.activeName = tab
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(){
      this.qstList = [
          {
            id:1,
            question:'我对计算机比较感兴趣，请问哪个专业比较适合我？请帮忙推荐一下。或者请您发我一份学校简介和招生简章，并且我想查看一下学校的往年招生录取分数线。' +
                '可以电话联系我：18888888888;或者邮箱联系：18888888888@888.com',
            time:'2021-06-06 08:40:02',
            nickName:'秦小白',
          }]
      return
      let params = {
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        status:this.searchForm.status,
        stu_type:'all',
        list_type:2
      }
      params.ktype = this.searchForm.ktype;
      params.keyword = this.searchForm.keyword;

      this.$http.post(api.stuList,params).then(res => {
        for (let item of res.data.data) {
          let city = item.graduate_sch_city.split(",")
          if (city.length >= 3) {
            item.city = city[1]
          }
        }
        this.tableData = res.data.data
        this.page.total = res.data.page.count
      })
    },
    showReply(row){
      this.visible = true
      this.editForm = row
    },
    reply(){
      if(!this.editForm.replyContent){
        this.$message.warning('回复不能为空！')
        return
      }else {
        this.$message.success('发送成功！')
      }
    },


    onSearch () {
      this.tableData = [];
      this.page.pageIndex = 1;
      this.getList();
    },
    onReset () {
      this.searchForm = {};
      this.tableData = [];
      this.page.pageIndex = 1;
      this.getList();
    },

  }
}
</script>

<style scoped lang="less" type="text/less">
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.app-container {
  .treeContainer {
    height: 100%;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
    border: 1px solid  rgba(220,223,230,0.6);

    .treeTitle {
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #409eff;
      padding-left: 6px;
    }
  }
}
</style>
